import { useState } from 'react'
import { Button, Card, CardContent, IconButton, Typography } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'

import { UpdateImpactCategory } from '../update-impact-type'
import { IImpactTypeBaseWithId } from 'src/types'

import { useStyles } from '../styles'
import { HelperWrapper } from 'src/components/helper-wrapper'

interface IImpactCategoryCardProps {
  item: IImpactTypeBaseWithId
  handleDelete: () => void
}

const ImpactTypeCard = ({ item, handleDelete }: IImpactCategoryCardProps) => {
  const [open, setOpen] = useState(false)
  const classes = useStyles()

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  return (
    <>
      <Card className={classes.cardWrapper}>
        <CardContent className={classes.cardContent}>
          <div className={classes.cardLeftWrapper}>
            <Typography className={classes.cardName} component="h4">
              {item.name}
            </Typography>
          </div>
          <div>
            <Button onClick={handleOpen}>
              <HelperWrapper t="update-button-text" />
            </Button>
            <IconButton onClick={handleDelete}>
              <DeleteIcon />
            </IconButton>
          </div>
        </CardContent>
      </Card>
      <UpdateImpactCategory handleClose={handleClose} open={open} initialValues={item} />
    </>
  )
}

export { ImpactTypeCard as ImpactCategoryCard }
